import * as types from './commonActionType';

export const exportToCSVRequest = data => ({
    type: types.EXPORT_TO_CSV_REQUEST,
    payload: data
});
export const exportToCSVSuccess = data => ({
    type: types.EXPORT_TO_CSV_SUCCESS,
    payload: data
});
export const exportToCSVFailure = data => ({
    type: types.EXPORT_TO_CSV_FAILURE,
    payload: data
});

export const dashboardDetailsRequest = () => ({
    type: types.DASHBOARD_DETAILS_REQUEST,
});

export const dashboardDetailsSuccess = data => ({
    type: types.DASHBOARD_DETAILS_SUCCESS,
    payload: data
});

export const dashboardDetailsFailure = data => ({
    type: types.DASHBOARD_DETAILS_FAILURE,
    payload: data
});

export const providerRequestDailyCountsRequest = endDate => ({
    type: types.PROVIDER_REQUEST_DAILY_COUNTS_REQUEST,
    payload: endDate
});

export const providerRequestDailyCountsSuccess = data => ({
    type: types.PROVIDER_REQUEST_DAILY_COUNTS_SUCCESS,
    payload: data
});

export const providerRequestDailyCountsFailure = data => ({
    type: types.PROVIDER_REQUEST_DAILY_COUNTS_FAILURE,
    payload: data
});

export const qgendaTasksSchedulesRequest = data => ({
    type: types.QGENDA_TASKS_SCHEDULES_REQUEST,
    payload: data
});

export const qgendaTasksSchedulesSuccess = data => ({
    type: types.QGENDA_TASKS_SCHEDULES_SUCCESS,
    payload: data
});

export const qgendaTasksSchedulesFailure = data => ({
    type: types.QGENDA_TASKS_SCHEDULES_FAILURE,
    payload: data
});

export const allowedMenusRequest = () => ({
    type: types.ALLOWED_MENUS_REQUEST
});

export const setAllowedMenus = (allowedMenus) => ({
    type: types.SET_ALLOWED_MENUS,
    payload: allowedMenus 
});

export const assignedSitesCountRequest = () => ({
    type: types.ASSIGNED_SITES_COUNT_REQUEST
});

export const assignedSitesCountSuccess = (count) => ({
    type: types.ASSIGNED_SITES_COUNT_SUCCESS,
    payload: count
});

export const assignedSitesCountFailure = () => ({
    type: types.ASSIGNED_SITES_COUNT_FAILURE
});

export const unassignedSitesCountRequest = () => ({
    type: types.UNASSIGNED_SITES_COUNT_REQUEST
});

export const unassignedSitesCountSuccess = (count) => ({
    type: types.UNASSIGNED_SITES_COUNT_SUCCESS,
    payload: count
});

export const unassignedSitesCountFailure = () => ({
    type: types.UNASSIGNED_SITES_COUNT_FAILURE
});

export const updateCommonReducer = (data) => ({
    type: types.UPDATE_COMMON_REDUCER,
    payload: data
});

export const assignedRolesWithPracticesRequest = () => ({
    type: types.ASSIGNED_ROLES_WITH_PRACTICES_REQUEST
});

export const assignedRolesWithPracticesSuccess = (data) => ({
    type: types.ASSIGNED_ROLES_WITH_PRACTICES_SUCCESS,
    payload: data
});

export const assignedRolesWithPracticesFailure = () => ({
    type: types.ASSIGNED_ROLES_WITH_PRACTICES_FAILURE
});

export const setShowLoader = (data) => ({
    type: types.SET_SHOW_LOADER,
    payload: data
});

export const tenantConfigurationRequest = (serverUrl) => ({
    type: types.TENANT_CONFIGURATION_REQUEST,
    payload: serverUrl
});

export const tenantConfigurationSuccess = (data) => ({
    type: types.TENANT_CONFIGURATION_SUCCESS,
    payload: data
});

export const tenantConfigurationFailure = (error) => ({
    type: types.TENANT_CONFIGURATION_FAILURE,
    payload: error
});

export const getTimezoneRequest = data => ({
    type: types.GET_TIMEZONE_REQUEST,
    payload: data
});

export const getTimezoneSuccess = data => ({
    type: types.GET_TIMEZONE_SUCCESS,
    payload: data
});

export const getTimezoneFailure = error => ({
    type: types.GET_TIMEZONE_FAILURE,
    payload: error
});

export const defaultWorklistsRequest = (userId) => ({
    type: types.DEFAULT_WORKLISTS_REQUEST,
    payload: { userId }
});

export const defaultWorklistsSuccess = (data) => ({
    type: types.DEFAULT_WORKLISTS_SUCCESS,
    payload: data
});

export const defaultWorklistsFailure = (data) => ({
    type: types.DEFAULT_WORKLISTS_FAILURE,
    payload: data
});
